function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 13.75C15.6528 13.75 13.75 15.6528 13.75 18C13.75 20.3472 15.6528 22.25 18 22.25C20.3472 22.25 22.25 20.3472 22.25 18C22.25 15.6528 20.3472 13.75 18 13.75ZM12.25 18C12.25 14.8244 14.8244 12.25 18 12.25C21.1756 12.25 23.75 14.8244 23.75 18C23.75 21.1756 21.1756 23.75 18 23.75C14.8244 23.75 12.25 21.1756 12.25 18Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 14.8501C18.4142 14.8501 18.75 15.1859 18.75 15.6001V17.5987L20.216 18.5761C20.5607 18.8058 20.6538 19.2715 20.424 19.6161C20.1943 19.9608 19.7286 20.0539 19.384 19.8241L17.584 18.6241C17.3753 18.485 17.25 18.2509 17.25 18.0001V15.6001C17.25 15.1859 17.5858 14.8501 18 14.8501Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.79301 2.87663C2.93705 2.34556 3.42593 1.9502 4 1.9502H20C20.574 1.9502 21.0628 2.34546 21.2069 2.87645L11.9998 9.32142L2.79301 2.87663ZM2.75 4.60427V15.2002C2.75 15.886 3.31421 16.4502 4 16.4502H9.00005C9.41426 16.4502 9.75005 16.786 9.75005 17.2002C9.75005 17.6144 9.41426 17.9502 9.00005 17.9502H4C2.48579 17.9502 1.25 16.7144 1.25 15.2002V3.20019C1.25 1.68598 2.48579 0.450195 4 0.450195H20C21.5142 0.450195 22.75 1.68598 22.75 3.20019V9.00019C22.75 9.41441 22.4142 9.75019 22 9.75019C21.5858 9.75019 21.25 9.41441 21.25 9.00019V4.60406L12.4127 10.7901C12.1648 10.9637 11.8349 10.9637 11.587 10.7901L2.75 4.60427Z",
  fill: "currentColor"
});

function SvgScheduledMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduledMail);
export default __webpack_public_path__ + "static/media/scheduled-mail.5ba4c5e9.svg";
export { ForwardRef as ReactComponent };